import {
  styled,
  rem
} from 'config/stitches.config'

import Link from '@/UI/Link'

export const StyledLogo = styled(Link, {
  gridArea: 'logo',
  justifySelf: 'start',
  paddingRight: '$3',
  pointerEvents: 'auto',
  padding: 0,
  width: rem(180),
  height: 'auto',
  '@md': {
    height: '100%',
    width: '100%',
  },

  'img': {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  variants: {
    mobile: {
      true: {
        'img': {
          width: rem(180),
          height: 'auto',
        },
      }
    }
  }
})
